module.exports = __webpack_public_path__ + "static/media/max-schultz-icon.040692a1.png";